module.exports = __webpack_public_path__ + "img/image8.51fe7a38.png";